<header class="header">
  <div class="left-section">
    <button class="toggle-sidebar-btn" (click)="sidebarService.toggle()" aria-label="메뉴 토글">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
        class="menu-icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
    <div class="title-section">
      <h1>BARO 관제</h1>
      <p class="subtitle">엘리베이터 모니터링 시스템</p>
    </div>
  </div>

  <!-- Elevator Status Summary (Desktop only) -->
  <div class="elevator-summary">
    <div class="summary-item">
      <span class="summary-label">전체</span>
      <span class="summary-value mono">{{ totalElevators() }}</span>
    </div>
    <span class="summary-divider"></span>
    <div class="summary-item">
      <span class="summary-dot bg-emerald"></span>
      <span class="summary-label">운행</span>
      <span class="summary-value text-emerald mono">{{ runningElevators() }}</span>
    </div>
    <span class="summary-divider"></span>
    <div class="summary-item">
      <span class="summary-dot bg-blue"></span>
      <span class="summary-label">대기</span>
      <span class="summary-value text-blue mono">{{ idleElevators() }}</span>
    </div>
    <span class="summary-divider"></span>
    <div class="summary-item">
      <span class="summary-dot bg-rose"></span>
      <span class="summary-label">경보</span>
      <span class="summary-value text-rose mono">{{ errorElevators() }}</span>
    </div>
    <span class="summary-divider"></span>
    <div class="summary-item">
      <span class="summary-dot bg-amber"></span>
      <span class="summary-label">점검</span>
      <span class="summary-value text-amber mono">{{ maintenanceElevators() }}</span>
    </div>
  </div>

  <div class="meta-section">
    <!-- Map Controls (Visible on Map Page only, placed before dark mode toggle) -->
    @if (mapTourService.isMapPage()) {
    <!-- Map Alarm Sound Toggle -->
    <button type="button" class="sound-toggle-btn" [class.active]="mapSoundService.isSoundEnabled()"
      [class.alarming]="mapSoundService.isPlaying()" (click)="mapSoundService.toggleSound()"
      [attr.aria-label]="mapSoundService.isSoundEnabled() ? '비상 알림음 끄기' : '비상 알림음 켜기'"
      [title]="mapSoundService.isSoundEnabled() ? (mapSoundService.isPlaying() ? '비상음 울리는 중 (클릭 시 음소거)' : '비상 알림음 켜짐 (클릭 시 음소거)') : '비상 알림음 꺼짐 (클릭 시 켜기)'"
      id="sound-toggle">
      @if (mapSoundService.isSoundEnabled()) {
      <svg class="sound-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.215-1.614.59-2.316.234-.847 1.058-1.354 1.938-1.354h2.24z" />
      </svg>
      <span class="sound-label">비상음</span>
      @if (mapSoundService.isPlaying()) {
      <span class="sound-pulse-dot"></span>
      }
      } @else {
      <svg class="sound-icon muted" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M17.25 9.75L19.5 12m0 0l2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-3.75l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.215-1.614.59-2.316.234-.847 1.058-1.354 1.938-1.354h2.24z" />
      </svg>
      <span class="sound-label">음소거</span>
      }
    </button>

    <button type="button" class="tour-toggle-btn" [class.active]="mapTourService.isTourActive()"
      (click)="mapTourService.toggleTour()"
      [attr.aria-label]="mapTourService.isTourActive() ? '자동 순회 중지' : '10초 간격 자동 순회 시작'"
      [title]="mapTourService.isTourActive() ? '자동 순회 중지' : '10초 간격 자동 순회 시작'" id="tour-toggle">
      <svg class="tour-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
      <span class="tour-label">자동 순회</span>
      @if (mapTourService.isTourActive()) {
      <span class="tour-pulse-dot"></span>
      }
    </button>
    }

    <!-- Dark Mode Toggle -->
    <button class="theme-toggle-btn" (click)="themeService.toggle()"
      [attr.aria-label]="themeService.isDark() ? '라이트 모드 전환' : '다크 모드 전환'" id="theme-toggle">
      @if (themeService.isDark()) {
      <svg class="theme-icon sun" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
      </svg>
      } @else {
      <svg class="theme-icon moon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
      }
    </button>

    <!-- Live Clock -->
    <div class="meta-item clock">
      <svg class="meta-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
      <span class="mono">{{ timeString() }}</span>
    </div>

    <!-- System Health Badge -->
    <div class="meta-item health-status">
      <span class="glow-dot" [class]="activeAlerts() > 0 ? 'rose pulse' : 'emerald pulse'"></span>
      <span class="label-text">{{ activeAlerts() > 0 ? '경고' : '정상' }}</span>
    </div>

    <!-- Quick Alarm Count -->
    @if (activeAlerts() > 0) {
    <div class="meta-item alarm-badge animate-blink">
      <svg class="meta-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      <span class="label-text"><span class="full-text">활성 경보 </span>{{ activeAlerts() }}개</span>
    </div>
    }
  </div>
</header>